import { render, staticRenderFns } from "./layoutHeader.vue?vue&type=template&id=2cb44776&scoped=true"
import script from "./layoutHeader.vue?vue&type=script&lang=js"
export * from "./layoutHeader.vue?vue&type=script&lang=js"
import style0 from "./layoutHeader.vue?vue&type=style&index=0&id=2cb44776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb44776",
  null
  
)

export default component.exports